import React, { useEffect, useState, useMemo } from "react";
import { useAppStore } from "../../../core/store/store";
import { AircraftMap } from "../Componets/AircraftMap";
import { createApi } from "../../../core/api";

export const DashboardOverview = () => {
  const bootstrap = useAppStore((s) => s.appActions?.bootstrap);
  const api = useMemo(() => createApi(), []);
  const [mapData, setMapData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    bootstrap?.();
  }, [bootstrap]);

  useEffect(() => {
    const load = async () => {
      setLoading(true);

      const res = await api.dashboard.getMapData(120);

      if (res?.ok) {
        // Handle both wrapped and flat responses
        const rawData = (res.data as any).data || res.data;
        setMapData(Array.isArray(rawData) ? rawData : []);
      } else {
        setMapData([]);
      }

      setLoading(false);
    };

    load();
  }, [api]);

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Loading map…
      </div>
    );
  }

  return (
    <div style={{ height: "100vh", width: "100%", overflow: "hidden" }}>
      <AircraftMap data={mapData} />
    </div>
  );
};
